'use client';

import { useState } from 'react';
import { useClientRendering } from '@/hooks/useClientRendering';
import useSendAnalytics from '@/hooks/useSendAnalytics';

interface EntryPageAnalyticsProps {
  id: number;
}

export function EntryPageAnalytics({ id }: EntryPageAnalyticsProps) {
  const [isSent, setIsSent] = useState(false);
  const sendAnalytics = useSendAnalytics();
  const isClient = useClientRendering();

  if (!isSent && isClient) {
    const source = new URLSearchParams(window.location.search).get('source');
    sendAnalytics('entryPage', { entryId: id, source });
    setIsSent(true);
  }

  return null;
}
